import React, { useState } from 'react';
import clsx from 'clsx';

interface DropBinProps {
  className?: string;
  content?: React.ReactNode;
  setContent?: (newContent: React.ReactNode | undefined) => void;
  value?: string;
  setValue?: (newValue: string | undefined) => void;
  showValue?: boolean;
  getContentFromValue?: (value: string) => string;
  onClick?: () => void;
}

export const DropBin = ({
  className,
  content,
  setContent,
  value,
  setValue,
  showValue = false,
  getContentFromValue = (value) => value,
  onClick,
}: DropBinProps) => {
  const [dropIntent, setDropIntent] = useState(false);

  return (
    <div
      className={clsx(
        'min-w-24 min-h-24 rounded-xl',
        dropIntent ? 'bg-neutral-100' : 'bg-neutral-50',
        className,
      )}
      aria-label="Drop letter here"
      onDragEnter={() => setDropIntent(true)}
      onDragLeave={() => setDropIntent(false)}
      onDragOver={(event) => event.preventDefault()}
      onDrop={(event) => {
        event.preventDefault();

        if (showValue) {
          const droppedValue = event.dataTransfer?.getData('text/plain');
          setValue?.(droppedValue);
        } else {
          const droppedHtml = event.dataTransfer?.getData('text/html');
          setContent?.(droppedHtml);
        }

        setDropIntent(false);
      }}
      onClick={() => onClick?.()}
    >
      {showValue ? getContentFromValue(value || '') : content}
    </div>
  );
};
